<template>
  <router-view>
    <v-container fluid grid-list-xl>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-layout row wrap>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.tip_client.value"
              :items="form.items.tipuriClient"
              :rules="form.rules.tip_client"
              :hint="fields.tip_client.value !== undefined ? fields.tip_client.value.hint : ''"
              item-text="label"
              item-value="type"
              :label="form.keywords.tip_client_label"
              validate-on-blur return-object box dense required
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.modalitate_racordare.value"
              :items="form.items.modalitatiRacordare"
              :rules="form.rules.modalitate_racordare"
              item-text="label"
              item-value="type"
              :label="form.keywords.modalitate_racordare_label"
              validate-on-blur return-object box dense required
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.transee_de_consum.value"
              :items="transeeDeConsumItems"
              :rules="form.rules.transee_de_consum"
              :no-data-text="form.keywords.transee_de_consum_no_data"
              item-text="label"
              item-value="type"
              :label="form.keywords.transee_de_consum_label"
              validate-on-blur return-object box dense required
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.tip_pret_unitar.value"
              :items="form.items.tipuriPreturiUnitare"
              :rules="form.rules.tip_pret_unitar"
              item-text="label"
              item-value="type"
              :label="form.keywords.tip_pret_unitar_label"
              validate-on-blur return-object box dense required
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="id_judet"
              :items="form.items.id_judet"
              :rules="form.rules.id_judet"
              :loading="fields.id_judet.loading"
              :label="form.keywords.judet_label"
              item-text="nume"
              item-value="judet"
              validate-on-blur box dense required
            ></v-select>
          </v-flex>
          <v-flex xs12 sm6 d-flex>
            <v-select
              v-model="fields.localitate.value"
              :items="form.items.localitate"
              :rules="form.rules.localitate"
              :loading="fields.localitate.loading"
              :no-data-text="form.keywords.localitate_no_data_label"
              item-text="localitateText"
              item-value="localitate"
              :label="form.keywords.localitate_label"
              validate-on-blur return-object box dense required
            ></v-select>
          </v-flex>
        </v-layout>
        <v-card>
          <v-card-title>
            <v-switch
              :label="form.keywords.mai_multe_label"
              v-model="mai_multe"
              color="primary"
              style="margin-top:0;"
            ></v-switch>
          </v-card-title>
          <transition name="slide-y-transition">
            <v-card-text v-show="mai_multe">
              <v-layout row wrap>
                <v-flex xs12 sm6>
                  <v-menu
                    v-model="menu"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="fields.data_start_aplicare.value"
                        v-bind="attrs"
                        v-on="on"
                        :label="form.keywords.data_start_aplicare_label"
                        :rules="form.rules.data_start_aplicare"
                        readonly box dense required
                      />
                    </template>
                    <v-date-picker
                      v-model="fields.data_start_aplicare.value"
                      @input="menu = false"
                    />
                  </v-menu>
                </v-flex>

                <v-flex xs12 sm6 d-flex>
                  <v-select
                    v-model="fields.tip_oferta.value"
                    :items="form.items.tipuriOferte"
                    :rules="form.rules.tip_oferta"
                    :hint="fields.tip_oferta.value !== undefined ? fields.tip_oferta.value.hint : ''"
                    item-text="label"
                    item-value="type"
                    :label="form.keywords.tip_oferta_label"
                    validate-on-blur return-object box dense required multiple
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 d-flex>
                  <v-select
                    v-model="fields.tip_pret_oferta.value"
                    :items="form.items.tipuriPretOferte"
                    :rules="form.rules.tip_pret_oferta"
                    :hint="fields.tip_pret_oferta.value !== undefined ? fields.tip_pret_oferta.value.hint : ''"
                    item-text="label"
                    item-value="type"
                    :label="form.keywords.tip_pret_oferta_label"
                    validate-on-blur return-object box dense required multiple
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 d-flex>
                  <v-select
                    v-model="fields.suplimentar_componenta_fixa.value"
                    :items="form.items.suplimentarComponenteFixe"
                    :rules="form.rules.suplimentar_componenta_fixa"
                    :hint="fields.suplimentar_componenta_fixa.value !== undefined ? fields.suplimentar_componenta_fixa.value.hint : ''"
                    item-text="label"
                    item-value="type"
                    :label="form.keywords.suplimentar_componenta_fixa_label"
                    validate-on-blur return-object box dense required
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 d-flex>
                  <v-select
                    v-model="fields.frecventa_emitere_factura.value"
                    :items="form.items.frecventeEmitereFactura"
                    :rules="form.rules.frecventa_emitere_factura"
                    :hint="fields.frecventa_emitere_factura.value !== undefined ? fields.frecventa_emitere_factura.value.hint : ''"
                    item-text="label"
                    item-value="type"
                    :label="form.keywords.frecventa_emitere_factura_label"
                    validate-on-blur return-object box dense required
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 d-flex>
                  <v-select
                    v-model="fields.termen_plata.value"
                    :items="form.items.termeneDePlata"
                    :rules="form.rules.termen_plata"
                    item-text="label"
                    item-value="type"
                    :label="form.keywords.termen_plata_label"
                    validate-on-blur return-object box dense required
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 d-flex>
                  <v-select
                    v-model="fields.durata_contractului.value"
                    :items="form.items.durateContract"
                    :rules="form.rules.durata_contractului"
                    item-text="label"
                    item-value="type"
                    :label="form.keywords.durata_contractului_label"
                    validate-on-blur return-object box dense
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 d-flex>
                  <v-select
                    v-model="fields.garantii.value"
                    :items="form.items.garantii"
                    :rules="form.rules.garantii"
                    item-text="label"
                    item-value="type"
                    :label="form.keywords.garantii_label"
                    validate-on-blur return-object box dense
                  ></v-select>
                </v-flex>

                <v-flex xs12 sm6 d-flex>
                  <v-select
                    v-model="fields.modul_transmitere_factura.value"
                    :items="form.items.moduriTransmitereFactura"
                    :rules="form.rules.modul_transmitere_factura"
                    item-text="label"
                    item-value="type"
                    :label="form.keywords.modul_transmitere_factura_label"
                    validate-on-blur return-object box dense
                  ></v-select>
                </v-flex>
              </v-layout>
            </v-card-text>
          </transition>
        </v-card>

        <v-card>
          <v-card-title>
            <v-switch
              :label="form.keywords.si_mai_multe_label"
              v-model="si_mai_multe"
              color="primary"
              style="margin-top:0;"
            ></v-switch>
            <transition name="slide-y-transition">
              <v-switch
                v-show="si_mai_multe"
                :label="`${form.keywords.unitate_de_consum_label}: ${unitate_consum.value.label}`"
                :hint="form.keywords.unitate_de_consum_hint"
                persistent-hint
                v-model="unitateConsumValue"
                prefix="KWh"
                color="primary"
                style="margin-top:0;"
              ></v-switch>
            </transition>
          </v-card-title>
          <transition name="slide-y-transition">
            <v-card-text v-show="si_mai_multe">
              <v-layout row wrap>
                <v-flex xs12 sm6 d-flex>
                  <v-text-field
                    v-model="fields.consum_mwh.value"
                    :rules="form.rules.consum_mwh"
                    :suffix="unitate_consum.value.label"
                    :label="form.keywords.consum_mwh_label"
                    type="tel" step="1" box dense required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 d-flex>
                  <v-text-field
                    v-model="fields.pret_furnizare_mwh.value"
                    :rules="form.rules.pret_furnizare_mwh"
                    :suffix="unitate_consum.value.label"
                    :label="form.keywords.pret_furnizare_mwh_label"
                    :hint="form.keywords.pret_furnizare_mwh_hint"
                    type="tel" step="1" box dense required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 d-flex>
                  <v-text-field
                    v-model="fields.componenta_fixa.value"
                    :rules="form.rules.componenta_fixa"
                    :label="form.keywords.componenta_fixa_label"
                    :hint="form.keywords.componenta_fixa_hint"
                    type="tel" step="1" box dense required
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-card-text>
          </transition>
        </v-card>

        <p class="text-xs-center">
          <v-btn color="primary" type="submit" @click.prevent="submit">{{ form.keywords.compara_preturi_label }}</v-btn>
        </p>
      </v-form>
    </v-container>
  </router-view>
</template>
<script>
  import {mapGetters} from 'vuex';
  import {makeQuery} from "@/modules/common.js";
  import {loadJudete, loadLocalitati} from '@/modules/gaz/judete.js';
  import makeForm from '@/modules/gaz/form.js';
  import moment from "moment/moment";

  const unitatiConsum = [{
      key: 'kwh',
      label: 'KWh',
      mul: 0.001
    },
    {
      key: 'mwh',
      label: 'MWh',
      mul: 1
    }
  ];

  export default {
    data: function () {
      return {
        valid: true,
        menu: false,
        mai_multe: false,
        si_mai_multe: false,
        unitate_consum: {
          items: unitatiConsum,
          value: unitatiConsum[0]
        },
        fields: {
          tip_client: {
            serialize: item => item.type,
            value: undefined
          },
          modalitate_racordare: {
            serialize: item => item.type,
            value: undefined
          },
          transee_de_consum: {
            serialize: item => item.type,
            value: undefined
          },
          id_judet: {
            items: [],
            loading: false,
            value: undefined
          },
          localitate: {
            items: [],
            loading: false,
            serialize: item => item.id_siruta,
            query_key: 'id_siruta',
            value: undefined
          },
          tip_pret_unitar: {
            serialize: item => item.type,
            value: undefined
          },
          termen_plata: {
            serialize: item => item === undefined ? undefined : item.type,
            value: undefined
          },
          durata_contractului: {
            serialize: item => item === undefined ? undefined : item.type,
            value: undefined
          },
          modul_transmitere_factura: {
            serialize: item => item.type,
            value: []
          },
          garantii: {
            serialize: item => item === undefined ? undefined : item.type,
            value: undefined
          },
          consum_mwh: {
            serialize: value => (number => isNaN(number) ? undefined : number * this.unitate_consum.value.mul)(parseFloat(value)),
            value: ""
          },
          pret_furnizare_mwh: {
            serialize: value => (number => isNaN(number) ? undefined : number / this.unitate_consum.value.mul)(parseFloat(value)),
            value: ""
          },
          data_start_aplicare: {
            value: ""
          },
          tip_oferta: {
            serialize: item => item.type,
            value: undefined
          },
          tip_pret_oferta: {
            serialize: item => item.type,
            value: undefined
          },
          suplimentar_componenta_fixa: {
            serialize: item => item.type,
            value: undefined
          },
          frecventa_emitere_factura: {
            serialize: item => item.type,
            value: undefined
          },
          componenta_fixa: {
            // serialize: value => (number => isNaN(number) ? undefined : number * this.unitate_consum.value.mul)(parseFloat(value)),
            value: ""
          }
        }
      }
    },
    computed: {
      ...mapGetters(['language']),
      form() {
        return makeForm(this.language, this);
      },
      unitateConsumValue: {
        get() {
          return this.unitate_consum.value.key === 'mwh';
        },
        set(v) {
          this.unitate_consum.value = v ? unitatiConsum[1] : unitatiConsum[0];
        }
      },
      transeeDeConsumItems() {
        if (this.fields.modalitate_racordare.value === undefined) {
          return [];
        }

        return this.form.items.transeeDeConsum.filter(tc => tc.filter.includes(this.fields.modalitate_racordare.value.type))
      },
      id_judet: {
        get() {
          return this.fields.id_judet.value;
        },
        set(v) {
          this.fields.id_judet.value = v;
          this.loadLocalitati();
        }
      }
    },
    methods: {
      onFieldError(e) {
        console.log(e)
      },
      loadJudete() {
        this.fields.id_judet.loading = true;
        return loadJudete(this.language)
          .then(response => response.json())
          .then(body => {
            this.form.items.id_judet = body.data.map(judet => ({
              ...judet,
              judet: judet.nume.toUpperCase()
            }))
          })
          .catch(e => {
            console.log(e);
          })
          .then(() => {
            this.fields.id_judet.loading = false;
          })
      },
      loadLocalitati() {
        this.fields.localitate.loading = true;

        return loadLocalitati(this.language, this.fields.id_judet.value)
          .then(response => response.json())
          .then(body => {
            this.form.items.localitate = body.data
              .map(({localitate_principala, localitate_apartinatoare, siruta}) => ({
                id_siruta: siruta,
                localitate: localitate_apartinatoare,
                localitateText: `${localitate_apartinatoare} (${localitate_principala})`
              }));
          })
          .catch(e => {
            console.log(e);
          })
          .then(() => {
            this.fields.localitate.loading = false;
          })
      },
      submit() {
        if (!this.$refs.form.validate()) {
          return;
        }

        const query = makeQuery(this.fields);

        this.$router.push({
          name: 'gaz.results',
          query
        });
      }
    },
    mounted() {
      this.loadJudete();
      this.$watch('form', (v) => {
        if (v) {
          this.fields.tip_client.value = v.items.tipuriClient[0];
          this.fields.modalitate_racordare.value = v.items.modalitatiRacordare[0];
          this.fields.transee_de_consum.value = v.items.transeeDeConsum[0];
          this.fields.tip_pret_unitar.value = v.items.tipuriPreturiUnitare[0];
          this.fields.data_start_aplicare.value = moment().format('YYYY-MM-DD');
          this.fields.tip_oferta.value = v.items.tipuriOferte[0];
          this.fields.tip_pret_oferta.value = v.items.tipuriPretOferte[0];
          this.fields.suplimentar_componenta_fixa.value = v.items.suplimentarComponenteFixe[0];
          this.fields.frecventa_emitere_factura.value = v.items.frecventeEmitereFactura[0];
          this.fields.termen_plata.value = v.items.termeneDePlata[0];
          this.fields.durata_contractului.value = v.items.durateContract[0];
          this.fields.garantii.value = v.items.garantii[0];
          this.fields.componenta_fixa.value = 0;
          this.fields.modul_transmitere_factura.value = v.items.moduriTransmitereFactura[0];

        }
      }, { immediate: true });
    }
  }
</script>
